export default "__VITE_ASSET__DQrPzvtr__"